module.exports = __webpack_public_path__ + "img/gear_run.d951de88.svg";